export default __webpack_public_path__ + "dcb329b8d4a7f8d02f9e15ae328fa75a.svg";